module.exports = __webpack_public_path__ + "static/media/yl-logo-color.6c12baee.svg";